export const ErrorPage = () => {
  return (
    <div>
      <p>Error</p>
    </div>
  );
};
